import script from "./ObstacleShape.vue?vue&type=script&lang=js"
export * from "./ObstacleShape.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__